import {
  CocoSadImageContainer,
  NpsFeedbackExplanationFormContainer,
  NpsFeedbackExplanationFormHeading,
  NpsFeedbackExplanationFormSubheading,
  SkipCTA,
  StyledButtonContainer,
  TextAreaWrapper
} from "./nps-feedback-explanation-form.styles";
import Image from "next/legacy/image";
import CocoSadImage from "public/assets/nps/coco-sad.svg";
import { Button } from "components/atoms/button/button";
import { useNpsFeedbackExplanationForm } from "./useNpsFeedbackExplanationForm";
import { TextArea } from "components/form-component/text-area/text-area";
import { Form } from "components/form-component/form/form";
import { IUseNpsFeedbackExplanationFormProps } from "./nps-feedback-explanation-form.types";

export const NpsFeedbackExplanationForm = ({
  submitFeedbackExplanationForm,
  handleModalClose
}: IUseNpsFeedbackExplanationFormProps): JSX.Element => {
  const {
    handleSubmit,
    handleSkip,
    handleFeedbackSubmission,
    isValid,
    control
  } = useNpsFeedbackExplanationForm({
    submitFeedbackExplanationForm,
    handleModalClose
  });

  return (
    <Form onSubmit={handleSubmit(handleFeedbackSubmission)}>
      <NpsFeedbackExplanationFormContainer>
        <CocoSadImageContainer>
          <Image
            src={CocoSadImage}
            alt="coco-sad-image"
            layout="responsive"
            height={144}
            width={144}
          />
        </CocoSadImageContainer>
        <NpsFeedbackExplanationFormHeading>
          Kenapa nggak tertarik rekomendasiin CoLearn?
        </NpsFeedbackExplanationFormHeading>
        <NpsFeedbackExplanationFormSubheading>
          Ceritain aja apa yang kurang dari kelasnya.
        </NpsFeedbackExplanationFormSubheading>
        <TextAreaWrapper>
          <TextArea
            name="comment"
            control={control}
            maxLength={250}
            placeholder="Tulis di sini, ya."
            showWordCount={true}
          />
        </TextAreaWrapper>
        <StyledButtonContainer>
          <Button variant="primary" isFullWidth={true} disabled={!isValid}>
            Kirim
          </Button>
        </StyledButtonContainer>
        <StyledButtonContainer>
          <SkipCTA
            variant={"ghost"}
            type="button"
            isFullWidth={true}
            onClick={handleSkip}
          >
            Lewati
          </SkipCTA>
        </StyledButtonContainer>
      </NpsFeedbackExplanationFormContainer>
    </Form>
  );
};
